import { useEffect, useState, ReactNode, useRef } from "react"

import { motion } from "framer-motion"
import { PanelRightClose } from "lucide-react"

import { ActionTooltipButton } from "@components/buttons/ActionTooltipButton"
import { AgentRunnerOverlayPanel } from "@components/panels/agent-runner/AgentRunnerOverlayPanel"

interface AgentRunnerOverlayProps {
    children: ReactNode
}
export function AgentRunnerOverlay({ children }: Readonly<AgentRunnerOverlayProps>) {
    const [isOpen, setIsOpen] = useState(false)

    const overlayRef = useRef<HTMLDivElement>(null)
    const panelRef = useRef<HTMLDivElement>(null)

    const handleClick = (e: any) => {
        e.stopPropagation()
        setIsOpen(true)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (!isOpen || !overlayRef.current || !panelRef.current) {
                return
            }

            if (panelRef.current.contains(event.target as Node)) {
                return
            }

            const isPopoverContent = (event.target as Element)?.closest('[data-state="open"][role="dialog"]') || (event.target as Element)?.closest("[data-radix-popper-content-wrapper]")

            if (isPopoverContent) {
                return
            }

            setIsOpen(false)
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [isOpen])

    return (
        <div className="flex items-center justify-center">
            <div onClick={handleClick} className="w-full align-left">
                {children}
            </div>

            {isOpen && (
                <div ref={overlayRef} className="z-[99] fixed w-full inset-0 bg-opacity-50 flex justify-end top-[var(--header-height)]">
                    <motion.div ref={panelRef} initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "spring", stiffness: 200, damping: 30 }} className="h-full w-[350px] bg-gray-50 shadow-lg p-0 relative">
                        <AgentRunnerOverlayPanel>
                            <ActionTooltipButton icon={<PanelRightClose />} variant="ghost" tooltip="Close overlay" onClick={() => setIsOpen(false)} />
                        </AgentRunnerOverlayPanel>
                    </motion.div>
                </div>
            )}
        </div>
    )
}
